import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanLoad, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';

import { NavigationService } from '../services/navigation.service';
import { GamificationProviderService } from '../services/gamification-provider.service';

/**
 * Guard for gamification routes.
 * Allows access when any gamification provider is enabled (Smartico, Promofy, NGX, etc.)
 */
@Injectable({
  providedIn: 'root',
})
export class GamificationGuard implements CanActivate, CanLoad {
  gamificationProviderService: GamificationProviderService = inject(GamificationProviderService);
  navigate: NavigationService = inject(NavigationService);

  private checkGamificationEnabled(): boolean {
    const isEnabled = this.gamificationProviderService.isAnyGamificationEnabled();

    if (!isEnabled) {
      this.navigate.goToCompanyMain();
    }

    return isEnabled;
  }

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _next: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkGamificationEnabled();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canLoad(route: any, segments: UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkGamificationEnabled();
  }
}
